import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ExecutivePortalsContext } from '../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider/ExecutivePortalsProvider';
import { EngagementPortalsContext } from '../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider/EngagementPortalsProvider';

const useUrlSlug = () => {
  const { allExecutivePortals } = useContext(ExecutivePortalsContext);
  const { allEngagementPortals } = useContext(EngagementPortalsContext);

  const getReservedUrls = useCallback(() => {
    return [...allExecutivePortals, ...allEngagementPortals].map(
      (p) => p.urlSlug,
    );
  }, [allEngagementPortals, allExecutivePortals]);

  const [urlSlug, setUrlSlug] = useState<string>('');
  const [isUrlSlugValid, setIsUrlSlugValid] = useState(false);

  const onUrlSlugChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setUrlSlug(event.target.value);
    },
    [],
  );
  const getIsUrlSlugValid = useCallback(() => {
    const isReservedUrl = getReservedUrls().some((url) => url === urlSlug);
    const isEmpty = urlSlug === '';
    const hasBannedCharacters = /[^a-zA-Z/-]/g.test(urlSlug);

    return !(isReservedUrl || isEmpty || hasBannedCharacters);
  }, [getReservedUrls, urlSlug]);

  useEffect(() => {
    setIsUrlSlugValid(getIsUrlSlugValid());
  }, [getIsUrlSlugValid]);

  return {
    urlSlug,
    setUrlSlug,
    onUrlSlugChanged,
    isUrlSlugValid,
  };
};

export default useUrlSlug;
